
import { defineComponent } from '@nuxtjs/composition-api';
import AnonymityLearnMoreModal from '@/components/partials/optional-anonymity/AnonymityLearnMoreModal/AnonymityLearnMoreModal.vue';
import Dropdown, { DropdownMenu } from '@/components/common/Dropdown';
import ProfileSelectorToggle from '@/components/partials/optional-anonymity/ProfileSelector/ProfileSelectorToggle.vue';
import ProfileSelectorMixin from '@/components/partials/optional-anonymity/ProfileSelector/ProfileSelectorMixin';
import { SelectorType } from '@/components/partials/optional-anonymity/ProfileSelector/types';
import { Activity } from '@/types/graphql';

export default defineComponent({
  name: 'ProfileSelector',
  components: {
    AnonymityLearnMoreModal,
    Dropdown,
    DropdownMenu,
    ProfileSelectorToggle,
    ProfileSelectorOption: () =>
      import('@/components/partials/optional-anonymity/ProfileSelector/ProfileSelectorOption.vue'),
    ProfileSelectorHelp: () =>
      import('@/components/partials/optional-anonymity/ProfileSelector/ProfileSelectorHelp.vue'),
    WarRoomUsernameAndAvatarModal: () =>
      import('@/components/partials/war-room/WarRoomSignUp/WarRoomUsernameAndAvatarModal.vue'),
  },
  mixins: [ProfileSelectorMixin],
  props: {
    withAvatar: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isAnonymous: {
      type: Boolean,
      default: null,
    },
    hint: {
      type: String,
      default: '',
    },
  },
  computed: {
    toggleSize() {
      return this.type === SelectorType.comment ? 'sm' : 'md';
    },
    editProfileType(): Activity | null {
      if (this.isAnonymous !== null) {
        return this.isAnonymous ? Activity.Anonymous : Activity.Public;
      }
      return null;
    },
  },
});
